import styled from '@emotion/styled';
import { Select } from '@mui/material';
import Theme from 'App.theme';

const DropDown = styled(Select)`
  background-color: ${Theme.greys.GREY0};

  & fieldset {
    border-color: ${Theme.greys.GREY0};
  }

  & :hover {
    & fieldset {
      border-color: ${Theme.greys.GREY1} !important;
    }
  }

  &.Mui-focused {
    & fieldset {
      border-color: ${Theme.greys.GREY1} !important;
    }
  }
`;

export default DropDown;
